import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useHistory } from "react-router-dom";
import TwitterFeed from "../components/TwitterFeed";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { LoopCircleLoading } from "react-loadingg";

const Home = () => {
  const history = useHistory();

  const [home, setHome] = useState([]);
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    fetch("https://revived-witch-api.herokuapp.com/home")
      .then((res) => res.json())
      .then(
        (result) => {
          setHome(result.homeData[0]);

          setIsLoaded(true);
        },
        (error) => {
          setError(error);
          setIsLoaded(true);
        }
      );
  }, []);

  if (error) {
    return <>{error.message}</>;
  } else if (!isLoaded) {
    return (
      <div style={{ height: "100vh", weight: "50%" }}>
        <LoopCircleLoading />
      </div>
    );
  } else {
    return (
      <>
        <Grid container spacing={2} style={{ marginTop: 20, marginBottom: 20 }}>
          <Grid item xs={12} md={8} sm={12}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6} sm={6}>
                <Card variant="outlined">
                  <CardMedia
                    component="img"
                    image={home.currentBanners.image}
                    alt="currentBanner"
                  />
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                      Current Banner
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {home.currentBanners.description}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      <strong> Summon Period :</strong>{" "}
                      {home.currentBanners.date}
                    </Typography>
                  </CardContent>
                  <CardActions></CardActions>
                </Card>
              </Grid>
              <Grid item xs={12} md={6} sm={6}>
                <Card variant="outlined">
                  <CardMedia
                    style={{ objectFit: "fill" }}
                    component="img"
                    image={home.currentBP.image}
                    alt="currentBP"
                  />
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                      Current Battle Pass
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {home.currentBP.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} md={6} sm={6}>
                <Card variant="outlined">
                  <CardMedia
                    component="img"
                    image={home.currentEvent.image}
                    alt="currentEvent"
                    style={{ objectFit: "fill" }}
                  />
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                      Current Event
                    </Typography>
                    <Typography gutterBottom variant="h5" component="div">
                      -
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {home.currentEvent.description}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      <strong> Event Period :</strong> {home.currentEvent.date}
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button
                      size="small"
                      onClick={() => history.push(`${home.currentEvent.link}`)}
                    >
                      Details
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
              <Grid item xs={12} md={6} sm={6}>
                <Card variant="outlined">
                  <CardMedia
                    component="img"
                    image="https://res.cloudinary.com/dt8txlhs2/image/upload/v1638320562/RevivedWitch/Story/tower_wmhcqo.jpg"
                    alt="story"
                    style={{ objectFit: "fill" }}
                  />
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                      Main Story Progress
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                    ></Typography>
                  </CardContent>
                  <CardActions>
                    <Button size="small" onClick={() => history.push(`story`)}>
                      Details
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={4} sm={6}>
            <Stack
              direction="row"
              justifyContent="center"
              alignItems="center"
              spacing={2}
            >
              <Avatar
                src="https://res.cloudinary.com/dt8txlhs2/image/upload/v1638662793/RevivedWitch/Items/goldenPetal_icon_jp1fzs.png"
                alt="petalIcon"
                style={{
                  width: 60,
                  height: 60,
                  borderRadius: "5px",
                }}
              />
              <Typography>Golden Petal Shop Month Rotation</Typography>
            </Stack>

            <TableContainer component={Paper}>
              <Table
                sx={{ minWidth: 200 }}
                size="small"
                aria-label="simple table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell align="justify">Month</TableCell>
                    <TableCell align="justify">UR</TableCell>
                    <TableCell align="justify">SSR</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {home.goldenPetalShop.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell align="justify">{row.month}</TableCell>
                      <TableCell align="justify">{row.ur}</TableCell>
                      <TableCell align="justify">{row.ssr}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TwitterFeed />
          </Grid>
        </Grid>
      </>
    );
  }
};

export default Home;
